// extracted by mini-css-extract-plugin
module.exports = {"formMedication":"MedicationForm_formMedication__3kvZ5","btnWrapper":"MedicationForm_btnWrapper__1Exv1"};